type pageContext = Record<string, string>;

export enum Brand {
    ORANGE = 'orange',
    SOSH = 'sosh',
}
export interface ChatBotInputs {
    brand: Brand;
    customerJourney?: string;
    userInfo?: { cid: string };
    pageContext?: pageContext;
    openWebchat?: boolean;
}
